import React from 'react';
import { ArrowLeft, Users, Award, BookOpen, Target, Building } from 'lucide-react';
import { Link } from 'react-router-dom';

const EstructuraOrganica = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <Link 
            to="/maestria" 
            className="inline-flex items-center gap-2 text-green-200 hover:text-white mb-6 transition-colors duration-300"
          >
            <ArrowLeft className="w-5 h-5" />
            Volver a Maestría
          </Link>
          <div className="flex items-center gap-4">
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl">
              <Building className="w-12 h-12" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-2">Estructura Orgánica</h1>
              <p className="text-xl text-green-100">
                Organización académica y administrativa del programa
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Organigrama Visual */}
        <section className="mb-16">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex items-center gap-3 mb-8">
              <Building className="w-8 h-8 text-[#0b742f]" />
              <h2 className="text-2xl font-bold text-gray-900">Organigrama Institucional</h2>
            </div>
            
            {/* Organigrama según la imagen */}
            <div className="bg-gray-50 rounded-lg p-8">
              <div className="flex flex-col items-center space-y-6">
                
                {/* Nivel 1: Consejo Universitario */}
                <div className="bg-blue-100 border-2 border-blue-300 rounded-lg p-4 text-center min-w-[200px]">
                  <h3 className="font-bold text-gray-800">CONSEJO<br/>UNIVERSITARIO</h3>
                </div>
                
                {/* Línea conectora */}
                <div className="w-px h-8 bg-gray-400"></div>
                
                {/* Nivel 2: Rector */}
                <div className="bg-blue-100 border-2 border-blue-300 rounded-lg p-4 text-center min-w-[200px]">
                  <h3 className="font-bold text-gray-800">RECTOR</h3>
                </div>
                
                {/* Líneas conectoras horizontales */}
                <div className="relative w-full max-w-4xl">
                  <div className="h-px bg-gray-400 w-full"></div>
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-px h-8 bg-gray-400"></div>
                </div>
                
                {/* Nivel 3: Secretarías */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-4xl">
                  <div className="flex flex-col items-center">
                    <div className="bg-blue-100 border-2 border-blue-300 rounded-lg p-4 text-center min-w-[180px] mb-6">
                      <h3 className="font-bold text-gray-800">SECRETARIA<br/>ACADÉMICA</h3>
                    </div>
                    
                    {/* Dependencias de Secretaría Académica */}
                    <div className="flex space-x-4">
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-center min-w-[120px]">
                        <h4 className="text-sm font-semibold text-gray-700">CONTROL<br/>ESCOLAR</h4>
                      </div>
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-center min-w-[120px]">
                        <h4 className="text-sm font-semibold text-gray-700">DOCENTES</h4>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex flex-col items-center">
                    <div className="bg-blue-100 border-2 border-blue-300 rounded-lg p-4 text-center min-w-[180px] mb-6">
                      <h3 className="font-bold text-gray-800">SECRETARIA<br/>ADMINISTRATIVA</h3>
                    </div>
                    
                    {/* Dependencias de Secretaría Administrativa */}
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-center min-w-[120px]">
                      <h4 className="text-sm font-semibold text-gray-700">SERVICIOS<br/>GENERALES</h4>
                    </div>
                  </div>
                </div>
                
                {/* Línea conectora central */}
                <div className="w-px h-8 bg-gray-400"></div>
                
                {/* Nivel 4: Consejo Divisional */}
                <div className="bg-blue-100 border-2 border-blue-300 rounded-lg p-4 text-center min-w-[200px]">
                  <h3 className="font-bold text-gray-800">CONSEJO<br/>DIVISIONAL</h3>
                </div>
                
                {/* Línea conectora */}
                <div className="w-px h-8 bg-gray-400"></div>
                
                {/* Nivel 5: División de Estudios */}
                <div className="bg-green-100 border-2 border-green-300 rounded-lg p-4 text-center max-w-[300px]">
                  <h3 className="font-bold text-gray-800">DIVISIÓN DE ESTUDIOS<br/>SOCIALES Y DE GESTIÓN E<br/>INTERNACIONALIZACIÓN</h3>
                </div>
                
                {/* Línea conectora final */}
                <div className="relative w-full max-w-md">
                  <div className="h-px bg-gray-400 w-full"></div>
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-px h-8 bg-gray-400"></div>
                </div>
                
                {/* Nivel 6: Departamentos */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4 text-center min-w-[180px]">
                    <h4 className="font-semibold text-gray-700">Departamento de<br/>Estudios Sociales</h4>
                  </div>
                  <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4 text-center min-w-[180px]">
                    <h4 className="font-semibold text-gray-700">Departamento de Gestión<br/>e Internacionalización</h4>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </section>

        {/* Descripción de Funciones */}
        <section className="mb-16">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Órganos de Gobierno */}
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl shadow-xl p-8 border border-blue-100">
              <div className="flex items-center gap-3 mb-6">
                <Users className="w-8 h-8 text-blue-600" />
                <h2 className="text-2xl font-bold text-gray-900">Órganos de Gobierno</h2>
              </div>
              <div className="space-y-6">
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h3 className="text-lg font-bold text-[#0b742f] mb-2">Consejo Universitario</h3>
                  <ul className="text-base text-gray-700 space-y-1">
                    <li>• Máximo órgano de gobierno de la institución</li>
                    <li>• Aprobación de políticas generales</li>
                    <li>• Supervisión de la calidad académica</li>
                    <li>• Decisiones estratégicas institucionales</li>
                  </ul>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h3 className="text-lg font-bold text-blue-600 mb-2">Rectoría</h3>
                  <ul className="text-base text-gray-700 space-y-1">
                    <li>• Representación legal de la institución</li>
                    <li>• Liderazgo ejecutivo y académico</li>
                    <li>• Coordinación general de actividades</li>
                    <li>• Relaciones interinstitucionales</li>
                  </ul>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h3 className="text-lg font-bold text-[#e87729] mb-2">Consejo Divisional</h3>
                  <ul className="text-base text-gray-700 space-y-1">
                    <li>• Gobierno colegiado de la división</li>
                    <li>• Aprobación de programas académicos</li>
                    <li>• Evaluación de desempeño docente</li>
                    <li>• Políticas específicas de la división</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Estructura Operativa */}
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl shadow-xl p-8 border border-green-100">
              <div className="flex items-center gap-3 mb-6">
                <Award className="w-8 h-8 text-green-600" />
                <h2 className="text-2xl font-bold text-gray-900">Estructura Operativa</h2>
              </div>
              <div className="space-y-6">
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h3 className="text-lg font-bold text-green-600 mb-2">Secretaría Académica</h3>
                  <ul className="text-base text-gray-700 space-y-1">
                    <li>• Gestión de programas educativos</li>
                    <li>• Coordinación del cuerpo docente</li>
                    <li>• Control escolar y servicios estudiantiles</li>
                    <li>• Evaluación y mejora académica</li>
                  </ul>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h3 className="text-lg font-bold text-purple-600 mb-2">Secretaría Administrativa</h3>
                  <ul className="text-base text-gray-700 space-y-1">
                    <li>• Administración de recursos humanos</li>
                    <li>• Gestión financiera y presupuestal</li>
                    <li>• Servicios generales e infraestructura</li>
                    <li>• Soporte tecnológico y logístico</li>
                  </ul>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h3 className="text-lg font-bold text-indigo-600 mb-2">División de Estudios Sociales</h3>
                  <ul className="text-base text-gray-700 space-y-1">
                    <li>• Coordinación de programas de posgrado</li>
                    <li>• Desarrollo de líneas de investigación</li>
                    <li>• Gestión e internacionalización</li>
                    <li>• Vinculación con sectores sociales</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Departamentos Académicos */}
        <section className="mb-16">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-l-4 border-[#e87729]">
            <div className="flex items-center gap-3 mb-8">
              <BookOpen className="w-8 h-8 text-[#e87729]" />
              <h2 className="text-2xl font-bold text-gray-900">Departamentos Académicos</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-green-50 rounded-lg p-6 border border-green-200">
                <h3 className="text-xl font-bold text-green-700 mb-4">Departamento de Estudios Sociales</h3>
                <div className="space-y-3">
                  <p className="text-base text-gray-700 mb-4">
                    Responsable del desarrollo y gestión de programas académicos en el área de ciencias sociales.
                  </p>
                  <h4 className="font-bold text-green-600 mb-2">Funciones principales:</h4>
                  <ul className="text-base text-gray-700 space-y-1">
                    <li>• Diseño curricular y actualización de planes de estudio</li>
                    <li>• Coordinación de profesores e investigadores</li>
                    <li>• Desarrollo de proyectos de investigación social</li>
                    <li>• Evaluación del desempeño académico</li>
                    <li>• Vinculación con organizaciones sociales</li>
                  </ul>
                </div>
              </div>
              
              <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
                <h3 className="text-xl font-bold text-blue-700 mb-4">Departamento de Gestión e Internacionalización</h3>
                <div className="space-y-3">
                  <p className="text-base text-gray-700 mb-4">
                    Enfocado en la gestión institucional y el desarrollo de relaciones internacionales.
                  </p>
                  <h4 className="font-bold text-blue-600 mb-2">Funciones principales:</h4>
                  <ul className="text-base text-gray-700 space-y-1">
                    <li>• Gestión de programas de intercambio académico</li>
                    <li>• Desarrollo de convenios internacionales</li>
                    <li>• Coordinación de movilidad estudiantil</li>
                    <li>• Gestión de proyectos de cooperación</li>
                    <li>• Promoción internacional de programas</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Procedimientos y Políticas */}
        <section>
          <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white rounded-2xl shadow-2xl p-8 md:p-12">
            <div className="flex items-center gap-3 mb-8">
              <Target className="w-8 h-8 text-[#e87729]" />
              <h2 className="text-3xl font-bold">Procedimientos y Políticas</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-bold text-green-100 mb-4">Políticas Académicas</h3>
                <ul className="space-y-3 text-green-50">
                  <li>• Admisión y selección de candidatos</li>
                  <li>• Asignación de tutores y comités</li>
                  <li>• Evaluación del desempeño académico</li>
                  <li>• Procesos de titulación</li>
                  <li>• Movilidad académica</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-bold text-green-100 mb-4">Procedimientos Administrativos</h3>
                <ul className="space-y-3 text-green-50">
                  <li>• Gestión de recursos académicos</li>
                  <li>• Administración de plataformas tecnológicas</li>
                  <li>• Control escolar y expedientes</li>
                  <li>• Servicios de apoyo estudiantil</li>
                  <li>• Evaluación y mejora continua</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default EstructuraOrganica;